import React from 'react';

import ReceiverListItem from './ReceiverListItem';

import { Card, CardContent, CardHeader, List, makeStyles } from '@material-ui/core';
import { PeopleAltOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme)=>({
    Card : {
        height : '100%',
        borderRadius : '0',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        backgroundColor: 'black',
        color: '#e5e7eb',
    },
    Text : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    CardContent : {
        maxHeight: '55vh',
        overflowY: 'auto',
    }
}))

const ReceiverList = function ReceiverList({ status,receivers, removeReceiver }){

    const classes = useStyles();

    var displayReceivers = () => {

        return receivers.map((receiver)=>{
            return(
                <ReceiverListItem key={receiver.nickname} status={ status[receiver._id] || "" } receiver={receiver} handleRemove={(receiverObj)=>{ removeReceiver(receiverObj._id); }} />
            )
        })

    }

    return(
        <Card classes={{ root : classes.Card }} >
            <CardHeader classes={{ title : classes.Text }} title={"Receivers( "+ receivers.length + " )"} avatar={ <PeopleAltOutlined /> } />
            <CardContent classes={{ root : classes.CardContent }} >
                <List>
                    {displayReceivers()}
                </List>
            </CardContent>
        </Card>
    )

}

export default ReceiverList;